const translations = {
  // Footer
  'კომპანიის შესახებ': 'Navigation',
  'ჩვენ შესახებ': 'About us',
  'კარიერა': 'Career',
  'პრეს-ცენტრი': 'Press-center',
  'პარტნიორებისთვის': 'For partners',
  'როგორ გავყიდოთ ციტრუსზე': 'How to sell citrus',
  'რეკლამის განთავსება': 'Ad placement',
  'კორპორაციული კლიენტები': 'Corporate clients',
  'მომხმარებლებისთვის': 'For customers',
  'მომხმარებლისთვის': 'For customers',
  'ხშირად დასმული კითხვები': 'Frequently asked questions',
  'გარანტია, დაბრუნება, გადაცვლა': 'Warranty, return, exchange',
  'მიტანის პირობები': 'Delivery terms',
  'წესები და პირობები': 'Terms and conditions',
  'უსაფრთხოების პოლიტიკა': 'Security policy',
  'კონტაქტი': 'Contact us',
  'ნავიგაცია': 'Navigation',
  'დაგვიკავშირდით': 'Contact Us',
  'სამუშაო საათები': 'Working Hours',
  'მისამართი': 'Address',

  // Header categories
  'ტექნიკა': 'Electronics',
  'Citrus შეთავაზებები & აუთლეტი': 'Deals',
}

const translateGe = text => {
  if (!text) return text
  return translations[text] || text
}

export default translateGe
